import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import { withRouter } from "../../../withRouter";
import BackIconButton from "../../givBee/buttons/BackIconButton";
import CreateSimilarIconButton from "../../givBee/buttons/CreateSimilarIconButton";
import DeleteIconButton from "../../givBee/buttons/DeleteIconButton";
import EditIconButton from "../../givBee/buttons/EditIconButton";
import PrintIconButton from "../../givBee/buttons/PrintIconButton";
import TreeIconButton from "../../givBee/buttons/TreeIconButton";
import "./AdminMenuWithBreadScrum.css";
import EmailIconButton from "../../givBee/buttons/EmailIconButton";
export class AdminMenuWithBreadScrum extends Component {
  constructor(props) {
    super(props);
    let headerClassName = "";
    this.state = {
      domainObject: this.props.domainObject,
      name: this.props.name,
      title: this.props.title,
      breadCrumb: this.props.breadCrumb,
      docTitle: this.props.docTitle,
      editCallback: this.props.editCallback,
      deleteCallback: this.props.deleteCallback,
      sendEmailCallback: this.props.sendEmailCallback,
      printCallback: this.props.printCallback,
      HierarchyCallback: this.props.HierarchyCallback,
      backCallback: this.props.backCallback,
      createSimilarCallback: this.props.createSimilarCallback,
      breadScrum: this.props.breadScrum,
      addToBreadCrumb: this.props.addToBreadCrumb,
      getDeletePermission: this.props.getDeletePermission,
      getCreatePermission: this.props.getCreatePermission,
      getUpdatePermission: this.props.getUpdatePermission,
      currentDateTime: new Date(new Date().getTime() + 1 * 24 * 60 * 60 * 1000),
      headerClassName: headerClassName,
      render: true,
      deleteClassName: this.props.deleteClassName,
      isSearchText: this.props.isSearchText,
      pageId: this.props.pageId,
    };
  }

  componentDidMount() {
    this.setState({ isSearchText: this.props.isSearchText });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isSearchText !== this.props.isSearchText) {
      this.setState({ isSearchText: this.props.isSearchText });
    }
  }

  /*Navigate to the click page*/
  goToPage(element) {
    if (this.props.pageId === "viewPage") {
      if (element.pageid) {
        if (this.props.navigate) {
          this.props.navigate(element.pageid, {
            state: {
              action: "view",
              businessDomain: this.props.businessDomain,
              businessType: this.props.businessType,
              businessUseCase: this.props.businessUseCase,
            },
          });
        }
      }
    } else if (this.props.pageId === "UseCase") {
      if (element.pageid) {
        if (this.props.navigate) {
          this.props.navigate(element.pageid, {
            state: {
              action: "view",
              businessDomain: this.props.businessDomain,
              businessType: this.props.businessType,
              businessUseCase: this.props.businessUseCase,
            },
          });
        }
      }
    } else {
      if (element.pageid) {
        if (this.props.navigate) {
          this.props.navigate(element.pageid);
        }
      }
    }
  }
  getBreadCrumb() {
    if (this.state.breadCrumb) {
      let array = [];
      this.props.breadCrumb.forEach((element, index) => {
        array.push(
          <Link
            key={index}
            style={{ color: "#000", fontSize: "small", cursor: "pointer" }}
            onClick={(e) => this.goToPage(element)}
          >
            <span>
              <i
                className={element.cssclass}
                style={{ color: "#c16767", fontSize: "small" }}
              ></i>
            </span>
            &nbsp;{element.uiname}
          </Link>
        );
      });
      if (this.state.addToBreadCrumb && this.state.addToBreadCrumb.length > 0) {
        array.push(
          <span key="999" style={{ color: "#000", fontSize: "small" }}>
            &nbsp;{this.state.addToBreadCrumb}
          </span>
        );
      }
      let home = { pageid: "/APDashboard", uiname: "Home" };
      return (
        <div style={{ float: "right", display: "flex" }}>
          <Breadcrumbs separator="›">
            <Link
              onClick={(e) => this.goToPage(home)}
              style={{ color: "#000", fontSize: "small", cursor: "pointer" }}
            >
              <HomeIcon
                style={{
                  color: "#c16767",
                  fontSize: "18px",
                  marginBottom: "3px",
                }}
              />
              &nbsp;{home.uiname}
            </Link>
            {array}
          </Breadcrumbs>
        </div>
      );
    } else {
      return <div />;
    }
  }

  render() {
    if (this.state.render === false) {
      return <div />;
    } else {
      let editIcon = null;
      if (this.state.editCallback && null !== this.state.editCallback) {
        this.props.getUpdatePermission === true &&
          (editIcon = (
            <EditIconButton
              domainObject={this.state.domainObject}
              onClick={this.state.editCallback}
            />
          ));
      }
      let deleteIcon = null;

      if (this.state.deleteCallback && null !== this.state.deleteCallback) {
        this.props.getDeletePermission === true &&
          (deleteIcon = (
            <DeleteIconButton
              domainObject={this.props.domainObject}
              onClick={this.state.deleteCallback}
              pageId={this.props.pageId}
              title={this.props.title}
            />
          ));
      }
      let printIcon = null;
      if (this.state.printCallback && null !== this.state.printCallback) {
        printIcon = (
          <PrintIconButton
            domainObject={this.state.domainObject}
            onClick={this.state.printCallback}
          />
        );
      }

      let emailIcon = null;
      if (
        this.state.sendEmailCallback &&
        null !== this.state.sendEmailCallback
      ) {
        emailIcon = (
          <EmailIconButton
            domainObject={this.state.domainObject}
            onClick={this.state.sendEmailCallback}
          />
        );
      }

      let TreeIcon = null;
      if (
        this.state.HierarchyCallback &&
        null !== this.state.HierarchyCallback
      ) {
        this.props.referenceAppointmentLength > 0 &&
          (TreeIcon = (
            <TreeIconButton
              domainObject={this.state.domainObject}
              onClick={this.state.HierarchyCallback}
            />
          ));
      }
      let backIcon = null;
      if (this.state.backCallback && null !== this.state.backCallback) {
        backIcon = (
          <BackIconButton
            domainObject={this.state.domainObject}
            onClick={this.state.backCallback}
          />
        );
      }

      let createSimilarIcon = null;
      if (
        this.state.createSimilarCallback &&
        null !== this.state.createSimilarCallback
      ) {
        createSimilarIcon = (
          <CreateSimilarIconButton
            domainObject={this.state.domainObject}
            onClick={this.state.createSimilarCallback}
            name="Duplicate"
          />
        );
      }

      let iconToolBar = null;

      if (
        null !== editIcon ||
        null !== deleteIcon ||
        null !== printIcon ||
        null !== emailIcon ||
        null !== backIcon
      ) {
        let docTitle = "";
        if (this.state.docTitle) {
          docTitle = <span>{this.state.docTitle} </span>;
        }

        iconToolBar = (
          <Row
            md={12}
            style={{
              font: "scan",
              margin: "auto auto",
              marginTop: "0.2em",
            }}
          >
            <Col
              md={1}
              style={{
                float: "left",
                fontSize: "large",
                alignSelf: "center",
                padding: "0px",
              }}
            >
              {null !== backIcon && backIcon}
            </Col>
            <Col
              md={3}
              style={{ float: "left", fontSize: "large", alignSelf: "center" }}
            >
              {docTitle}
            </Col>
            <Col
              md={8}
              style={{ float: "right", margin: "auto", padding: "0px" }}
            >
              {null !== deleteIcon && deleteIcon}
              {null !== editIcon && editIcon}

              {null !== TreeIcon && TreeIcon}
              {null !== createSimilarIcon && createSimilarIcon}
              {null !== printIcon && printIcon}
              {null !== emailIcon && emailIcon}
            </Col>
          </Row>
        );
      }
      return (
        <>
          <Row>
            <Col md={6}>
              {" "}
              <h5
                style={{
                  textTransform: "capitalize",
                  textAlign: "left",
                }}
              >
                <b>{this.props.name}</b>
              </h5>
            </Col>
            <Col md={6} style={{ textTransform: "none", textAlign: "end", alignSelf: "end", paddingRight: "38px" }}>
              {/* {this.getBreadCrumb()} */}
              {this.state.isSearchText &&
                <span
                  style={{
                    color: "red",
                    fontWeight: "700",
                    cursor: "pointer",
                    fontSize: "12px",
                  }}
                >
                  Search results are being displayed.
                </span>
              }
            </Col>
          </Row>
          <Row
            md={12}
            className={this.state.headerClassName}
            style={{ marginBottom: "0.5em" }}
          >
            <Col md={12}>{null !== iconToolBar && iconToolBar}</Col>
          </Row>
        </>
      );
    }
  }
}

export default withRouter(AdminMenuWithBreadScrum);
